// extracted by mini-css-extract-plugin
export default {"paddingTop":"styles_paddingTop__1Tuq8","responsive":"styles_responsive__162Tb","container":"styles_container__T0Rbi"};